module.exports = __webpack_public_path__ + "static/media/YF55_4.68976123.jpg";